import(/* webpackMode: "eager", webpackExports: ["BlogOverview"] */ "/tmp/8de9bad6046f12a/app/[locale]/blog/BlogOverview.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/app/[locale]/blog/page.module.css");
